var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DocumentUpload"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileSelected}}),_vm._v(" "),_c('button',{on:{"click":_vm.onSubmit}},[_vm._v("Upload")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-050130c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inputs/DocumentUpload/DocumentUpload.vue
// module id = null
// module chunks = 